export const testimonialsData = [
  {
    author: {
      image: "/assets/images/avatar.webp",
      name: "Dr. Mohamed Ali",
      position: "Research Scientist",
    },
    quote: "BioStat transformed my research with clear and fast analysis!",
  },
  {
    author: {
      image: "/assets/images/avatar.webp",
      name: "Dr. A. Hussein",
      position: "Biostatistician",
    },
    quote:
      "The workshops provided by BioStat are invaluable for any researcher!",
    rating: 5,
  },
  {
    author: {
      image: "/assets/images/avatar.webp",
      name: "Dr. Sarah Johnson",
      position: "Clinical Researcher",
    },
    quote:
      "I gained practical skills that I could apply immediately to my work.",
    rating: 4.5,
  },
  {
    author: {
      image: "/assets/images/avatar.webp",
      name: "Dr. Emily Carter",
      position: "Epidemiologist",
    },
    quote:
      "The insights I gained from BioStat's workshops were game-changing for my research.",
    rating: 5,
  },
];
